import { gql } from '@apollo/client';

export const EXPERIMENT_ATTRIBUTES = gql`
  fragment experimentAttributes on Experiment {
    id
    campaign {
      id
      name
      type
      state
      messageMedium
      sendTimeUseRecipientTimeZones
      labels {
        id
        name
      }
      # TODO: Remove conversions once the analytics page refactor FF is removed
      conversions {
        events {
          name
        }
      }
    }
    name
    type
    createdAt
    createdBy {
      id
      fullName
    }
    modifiedAt
    startedAt
    endedAt
    exploitationStartedAt
    state
    evenlySplitVariations
    winningCriteria {
      type
      name
    }
  }
`;

export const EDIT_EXPERIMENT_VARIANT_ATTRIBUTES = gql`
  fragment editExperimentVariantAttributes on ExperimentVariation {
    id
    name
    control
    sendTime
    content(locale: $locale) {
      ... on EmailContentDefinition {
        subject
        preheaderText
        fromName
        fromEmail
        replyTo
      }
      ... on SMSContentDefinition {
        message
        imageUrl
      }
      ... on PushContentDefinition {
        title
        message
      }
      ... on WebPushContentDefinition {
        title
        message
        icon
        clickAction
      }
    }
  }
`;

export const EDIT_EXPERIMENT_ATTRIBUTES = gql`
  fragment editExperimentAttributes on Experiment {
    id
    name
    type
    state
    campaign {
      id
      name
      type
      state
      sendTimeUseRecipientTimeZones
      messageMedium
      conversions {
        id
        events {
          name
          attributionMode {
            ... on LastMessaged {
              periodHours
            }
          }
        }
      }
      lists {
        id
      }
    }
    evenlySplitVariations
    testSendsPerVariation
    attributionPeriodHours
    testSizePercentage
    testDurationInMinutes
    winningCriteria {
      type
      name
    }
    holdout {
      ... on GroupPercentHoldoutDefinition {
        percent
        holdoutUserCount
      }
    }
    variations {
      ... on ExperimentVariation {
        ...editExperimentVariantAttributes
      }
    }
  }
  ${EDIT_EXPERIMENT_VARIANT_ATTRIBUTES}
`;

export const ANALYTICS_PAGE_EXPERIMENT_ATTRIBUTES = gql`
  fragment analyticsPageExperimentAttributes on Experiment {
    id
    campaign {
      id
      name
      type
      state
      messageMedium
      sendTimeUseRecipientTimeZones
      labels {
        id
        name
      }
      conversions {
        events {
          name
        }
      }
    }
    name
    type
    createdAt
    createdBy {
      id
      fullName
    }
    modifiedAt
    startedAt
    endedAt
    exploitationStartedAt
    state
    evenlySplitVariations
    winningCriteria {
      type
      name
    }
    testSizePercentage
    testDurationInMinutes
    attributionPeriodHours
    testSendsPerVariation
  }
`;

export const EXPERIMENT_VARIANT_ATTRIBUTES = gql`
  fragment experimentVariantAttributes on ExperimentVariation {
    id
    messageMedium
    name
    winner
    control
    templateThumbnailUrl
    sendTime
    content {
      ... on EmailContentDefinition {
        subject
        preheaderText
        fromName
        fromEmail
      }
      ... on SMSContentDefinition {
        smsSender {
          name
          phoneNumber
        }
      }
    }
  }
`;

export const ANALYTICS_METRICS_ATTRIBUTES = gql`
  fragment variantMetricsAndHoldoutAttributes on KVAnalyticsMetricAnalyticsMetricResultDefinition {
    key {
      metricName
    }
    value {
      ... on AnalyticsMetricDoubleResultDefinition {
        value
        histogram {
          buckets {
            time
            value
          }
        }
      }
      ... on AnalyticsMetricTermsResultDefinition {
        terms {
          term
          value
          histogram {
            buckets {
              time
              value
            }
          }
        }
      }
    }
  }
`;

export const ANALYTICS_PAGE_BASE_DATA = gql`
  fragment analyticsPageBaseDataAttributes on Experiment {
    ...analyticsPageExperimentAttributes
    holdout {
      ... on GroupPercentHoldoutDefinition {
        percent
      }
    }
    variations {
      ... on ExperimentVariation {
        ...experimentVariantAttributes
      }
    }
  }
  ${ANALYTICS_PAGE_EXPERIMENT_ATTRIBUTES}
  ${EXPERIMENT_VARIANT_ATTRIBUTES}
`;
